<template>
    <div class="vh-100">

        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left">
                    <div class="header-item" @click="back">
                        <div class="icon-24 icon-arrow-left"></div>
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Daftar</div>
                <div class="header-top--right">
                    <div class="header-item"></div>
                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <main class="content-wrapper main-page flex-100">

            <div class="p-y-16 p-x-20 w-limit flex-1">
                <div class="badge-tag tg-blue f-14">
                    Langkah <b>1 / 3</b>
                </div>

                <div class="f-16 m-t-16">
                    Silakan masukkan <b>nomor WhatsApp</b> Anda, Kami akan mengirimkan kode OTP untuk <b>verifikasi</b>
                </div>

                <form class="m-t-16" action="">
                    <label for="input-1" class="form-label require">Nomor WhatsApp anda</label>
                    <div class="input-group mod">
                        <div class="input-group-prepend">
                            <vue-country-code
                                    @onSelect="onSelect"
                                    :preferredCountries="['id', 'my', 'bn']">
                            </vue-country-code>
                        </div>
                        <input type="tel" class="form-control" id="input-1" placeholder="81757875431"
                            v-on:keyup="nomorWaOnkeyup" v-on:keydown="nomorWaOnkeyup" v-model="telp">
                    </div>
	                <ErrorMessage class="error" label="Nomor Whatsapp" :validation="$v.telp"></ErrorMessage>
                </form>

                <div class="f-13 m-t-16">
                    <span class="f-c-midgrey">Sudah punya akun? </span>
                    <a class="f-c-blue" @click="gologin">Login disini</a>
                </div>

            </div>

            <div class="p-x-20 p-y-20 w-limit">
                <vue-recaptcha ref="recaptcha" @verify="onCaptchaVerified" @expired="onCaptchaExpired" size="invisible"
                    sitekey="6Lc_X9QZAAAAAI0vmQNzNDQG-rKZ7NOE0O3wq5W9">
                </vue-recaptcha>
                <button class="btn smart-primary" id="nextbutton" @click="submit">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        v-if="isClicked === true"></span>
                    <span id="textBtn1">Daftar</span>
                </button>
            </div>
        </main>
    </div>
</template>
<script>
    import VueRecaptcha from 'vue-recaptcha';
    import ErrorMessage from "@/component-items/ErrorMessage";
    import {minLength, maxLength, required} from "vuelidate/lib/validators";

    export default {
        name: "Register",
        components: {
            'vue-recaptcha': VueRecaptcha,
	        ErrorMessage
        },
        data() {
            return {
                telp: '',
                isClicked: false,
                telpCode:"62"

            }
        },
	    validations: {
        	telp: {
        		required,
		        minLength: minLength(8),
		        maxLength: maxLength(12),
	        }
	    },
        mounted() {
            $('#input-1').focus()
            $('#close').hide()
            if ("telp" in localStorage) {
                var nomorTelp = localStorage.getItem("telp");
                var charLenght = nomorTelp.length;
                if (charLenght > 0) {
                    var codeCountry = nomorTelp.substring(0, 2);
                    if (codeCountry == this.telpCode) {
                        var realPhone = nomorTelp.substring(2, charLenght);
                        this.telp = realPhone;
                        $('#input-1').focus();
                        $('#nextbutton').prop('disabled', false);
                    }
                }
            }
            if ("telp" in localStorage) {
                if ("token" in localStorage) {
                    this.$router.push('/dashboard')
                }
            }
            //inisialisasi external script
            let recaptchaScriptVerifikasi = document.createElement('script')
            recaptchaScriptVerifikasi.setAttribute('src',
                'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit')
            document.head.appendChild(recaptchaScriptVerifikasi)

            $('body').on('DOMSubtreeModified', '.grecaptcha-badge', function () {
                $(".grecaptcha-badge").hide()
            });
        },
        methods: {
            onSelect({name, iso2, dialCode}) {
                this.telpCode=dialCode
            },

            submit() {
	            if (this.$v.telp.$invalid) {
		            this.$v.telp.$touch()
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
		            return true
	            }
                this.$refs.recaptcha.execute();
            },
            onCaptchaVerified: function (recaptchaToken) {
                this.getOTP(recaptchaToken)
                const self = this;
                self.$refs.recaptcha.reset();
            },
            onCaptchaExpired: function () {
                this.$refs.recaptcha.reset();
            },
            back() {
                this.$router.push('/startscreen')
            },
            gologin() {
                this.$router.push('/login')
            },
            nomorWaOnkeyup(event) {
                var phoneField = event.target.value;
                var frstCar = phoneField.substring(0, 1);
                var firstTel = phoneField.substring(1, 13);
                var secCar = phoneField.substring(0, 2);
                var secTel = phoneField.substring(2, 13);
                var thrdcar = phoneField.substring(0, 12);
                var output
                if (frstCar == 0) {
                    output = firstTel
                } else if (secCar == this.telpCode) {
                    output = secTel
                } else {
                    output = thrdcar
                }
                var number = output.replace(/[^0-9]+/, '');
                var charLenght = number.length;
                if (charLenght >= 8 && charLenght <= 12) {
                    // $('#nextbutton').prop('disabled', false);
                } else {
                    // $('#nextbutton').prop('disabled', true);
                }
                this.telp = number;
            },
            async getOTP(recaptchaToken) {
                this.isClicked = true;
                $('#nextbutton').prop('disabled', true)
                $('#textBtn1').hide()
                var telpStr = this.telp
                var replaceTelp = telpStr.replace(/-/g, "");
                var replaceSpace = replaceTelp.replace(/\s/g, "");
                var fixTelp = replaceSpace.replace(/\+/g, "");
                try {
                    const dataotp = new FormData;
                    dataotp.append('telp', (fixTelp.length > 0) ? this.telpCode + fixTelp : "");
                    dataotp.append('token_captcha', recaptchaToken);
                    const res = await this.$axios.post(this.$baseurl + '/auth/send_otp_with_captcha', dataotp);
                    if (res.status === 200) {
                        if (res.data.status) {
                            localStorage.setItem('telp', this.telpCode + fixTelp)
                            setTimeout(() => {
                                this.$router.push({
                                    name: 'verifikasiregis',
                                    params: {
                                        telp: this.telp
                                    }
                                })
                            }, 1000)
                        } else {
                            this.$toast.error(res.data.msg)

                            $('#nextbutton').prop('disabled', false)
                            this.isClicked = false
                            $('#textBtn1').show();
                            $('#buttonSendOtp').prop('disabled', false);
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)

                    $('#nextbutton').prop('disabled', false)
                    this.isClicked = false
                    $('#textBtn1').show();
                    $('#buttonSendOtp').prop('disabled', false);
                }
            },
        },
    }
</script>